const statusList = [
  {
    label: 'Pesanan Dibuat',
    labelBtn: 'Assign',
    value: 'WAITING'
  },
  {
    label: 'Menunggu Konfirmasi',
    labelBtn: 'Konfirmasi',
    value: 'ASSIGNING'
  },
  {
    label: 'Terkonfirmasi',
    value: 'CONFIRM'
  },
  {
    label: 'Penjemputan',
    value: 'PICKUP'
  },
  {
    label: 'Di Lokasi Penjemputan',
    value: 'LOAD'
  },
  {
    label: 'Pengiriman',
    value: 'DELIVER'
  },
  {
    label: 'Di Lokasi Tujuan',
    value: 'UNLOAD'
  },
  {
    label: 'Diterima Utuh',
    value: 'COMPLETE_FULL'
  },
  {
    label: 'Diterima Tidak Utuh',
    value: 'COMPLETE_HALF'
  },
  {
    label: 'Ditolak',
    value: 'COMPLETE_REJECT'
  },
  {
    label: 'Dibatalkan',
    value: 'CANCEL'
  },
  {
    label: 'Kedaluwarsa',
    value: 'EXPIRED'
  },
  {
    label: 'BAP Diterima Gudang',
    labelBtn: 'BAP Penerimaan',
    value: 'COMPLETE_IN_STORE'
  },
  {
    label: 'BAP - Kembali ke Gudang Asal',
    labelBtn: 'BA Penerimaan',
    value: 'COMPLETE_RETURN_ORIG'
  },
  {
    label: 'BAP - Ganti Lokasi Tujuan',
    labelBtn: 'BA Penerimaan',
    value: 'COMPLETE_CHANGE_DEST'
  },
  {
    label: 'BAP - Konfirmasi Shipper',
    labelBtn: 'BAP - Konfirmasi Shipper',
    value: 'NEED_CONFIRM'
  },
]

const calculationStatusList = [
  {
    label: 'Belum di hitung',
    value: 'CALCULATED_UNIT',
  },
  {
    label: 'Sudah di hitung',
    value: 'CALCULATED_PRICE',
  },
]

const podStatusList = [
  {
    label: 'Semua',
    value: -1,
  },
  {
    label: 'Sudah POD',
    value: 1,
  },
  {
    label: 'Belum POD',
    value: 0,
  },
]

const statusCategory = {
  waiting: ['WAITING', 'ASSIGNING'],
  inProcess: [
    'CONFIRM',
    'PICKUP',
    'LOAD',
    'DELIVER',
    'UNLOAD',
    'NEED_CONFIRM',
  ],
  completed: [
    'COMPLETE_FULL',
    'COMPLETE_HALF',
    'COMPLETE_REJECT',
    'CANCEL',
    'EXPIRED',
    'COMPLETE_CHANGE_DEST',
    'COMPLETE_RETURN_ORIG',
    'COMPLETE_IN_STORE',
  ]
}

const isDisplayDamagedMissingDetail = (status) => [
  'COMPLETE_HALF',
  'COMPLETE_REJECT',
  'COMPLETED_IN_STORE',
  'COMPLETE_IN_STORE',
  'COMPLETED_RETURN_ORI',
  'COMPLETE_RETURN_ORIG',
  'COMPLETED_CHANGE_DESTINATION',
  'COMPLETE_CHANGE_DESTINATION',
  'COMPLETED_CHANGE_DEST',
  'COMPLETE_CHANGE_DEST',
  'NEED_CONFIRM',
].includes(status)

const getStatusText = function (value, isButton) {
  console.log('getStatusText -> value', value)
  if (isButton && (value === 'WAITING')) return statusList.find(i => i.value === value).labelBtn
  const status = statusList.find(i => i.value === value)
  return status ? status.label : ''
}

export default {
  orderNo: 'No Pesanan',
  searchNo: 'Cari No. Kiriman/Pesanan',
  shipmentGroupNo: 'No Kiriman',
  customerName: 'Nama Customer',
  transporterName: 'Rekanan 3PL',
  vehicle: 'Kendaraan',
  driver: 'Sopir',
  originLocation: 'Lokasi Asal',
  destinationLocation: 'Lokasi Tujuan',
  shipmentDate: 'Tanggal Pengiriman',
  note: 'Catatan',
  status: 'Status Pesanan',
  qty: 'Quantity',
  ritase: 'Ritase',
  weight: 'Kilo',
  box: 'Box',
  volume: 'Kubikasi',
  onCall: 'OnCall',
  completeOrder: 'Selesaikan Pesanan',
  cancel: 'Batalkan Pesanan',
  cancelPromptText: 'Apakah anda yakin ingin membatalkan pesanan ini?',
  cancellationNoteValidationText: 'Catatan pembatalan diperlukan',
  cancellationNoteLabel: 'Catatan',
  completeOrderDialogHeader: 'Menyelesaikan Pesanan ',
  completeOrderNoteLabel: 'Catatan',
  completeOrderStatusOptionsLabel: 'Status',
  addDocumentationPhotosButtonLabel: 'Tambah Foto Dokumentasi',
  uploadDocumentPhotosDialogTitle: 'Unggah Foto Dokumentasi',
  documentPhotosInputLabel: 'Foto dokumentasi',
  documentTypeOptionsLabel: 'Tipe dokumen',
  reason: 'alasan: ',
  statusList,
  statusCategory,
  getStatusText,
  calculationStatusList,
  label3PL: 'Rekanan 3PL',
  vehicleNumber: 'No. Kendaraan',
  orderShipNo: 'No Kiriman',
  acceptInStore: 'Barang Diterima Gudang',
  isDisplayDamagedMissingDetail,
  podStatusList,
}
